import {
  first,
  switchMap,
  map,
  take,
  filter,
  tap,
  withLatestFrom
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as newsActions from '../actions/news.actions';
import * as fromRoot from '../reducers';

@Injectable()
export class NewsGuardService implements CanActivate {
  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private posts$: Observable<any>
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => {
        return this.hasArticle(parseInt(route.params.id, 10));
      })
    );
  }

  hasArticle(id: number): Observable<boolean> {
    return this.store.select(fromRoot.getNewsArticleById(id)).pipe(
      switchMap((article) => {
        if (!article) {
          this.router.navigateByUrl('/news');
        }
        return of(!!article);
      })
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromRoot.getLoadedStatus).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.store.dispatch(newsActions.GetNews());
        }
      }),
      filter((loaded) => loaded),
      take(1)
    );
  }
}
